import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=2245c488&scoped=true&"
import script from "./ContactEdit.vue?vue&type=script&lang=js&"
export * from "./ContactEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=2245c488&scoped=true&lang=css&"
import style1 from "./ContactEdit.vue?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/requests.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245c488",
  null
  
)

export default component.exports